
import React, { Component } from 'react'
import CommonTableModule from '../CommonTable/CommonTableModule';
import { Alert, Badge, Button, Card, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import axios from "axios";
import CommonLoader from '../loaderComponent/CommonLoader';
import { hasPermission } from '../../utils/usePermission';
import { exportAttendanceCsv } from '../../utils/exportAttendanceCsv';
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default class ExpenseList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expenseData: [],
      employeeWise: [],
      employee: "",
      employeesData: [],
      date: new Date().toISOString().split("T")[0],
      loading: true,
      expandedRows: {},
      hasError: false,
      errMsg: ""
    };
  }

  toggleRow = (empid) => {
    this.setState(prevState => ({
      expandedRows: {
        ...prevState.expandedRows,
        [empid]: !prevState.expandedRows[empid]
      }
    }));
  };

  async componentDidMount() {
    this.setState({ loading: true })
    // this.fetchExpenseData()
    this.fetchEmployeeData()
  }

  handleFilterChange = (event) => {
    this.setState({ [event.target.name]: event.target.value, loading: false });
  };

  fetchEmployeeData = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/users', { headers });
      this.setState({ employeesData: response?.data });
      setTimeout(() => {
        this.setState({ loading: false });
      }, 900);
    } catch (error) {
      let errorMessage = "Failed to load employee.";

      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }


  fetchExpenseData = async () => {

    const { employee, startDate, endDate } = this.state;

    if (!startDate || !endDate) {
      this.setState({ hasError: true, errMsg: "Please select a Date Range." });
      return;
    }

    this.setState({ loading: true });

    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    };

    let requestData = { startDate, endDate };

    if (employee && employee !== "all") {
      requestData.empid = employee;
    }

    try {
      const response = await axios.post("/advancePayment/expense-list", requestData, { headers });
      console.log(response.data);
      this.setState({ employeeWise: response?.data?.employeeWiseData, loading: false, showExcelButton: true });
    } catch (error) {
      console.error("Error fetching attendance:", error);
      let errorMessage = "Failed to load attendance list.";
      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  };

  render() {

    const columns = [
      { key: "empid", label: "emp ID" },
      { key: "employeeName", label: "Name" },
      { key: "username", label: "Username" },
      { key: "jobTitle", label: "Job Title" },

      { key: "totalAmount", label: "Total Amount" },
      { key: "paymentCount", label: "payment Count" },
      {
        key: "latestPayment",
        label: "Latest Payment",
        render: (value, row) => {
          if (row.paymentDetails && row.paymentDetails.length > 0) {
            const latest = row.paymentDetails[0]; // DESC order में हैं
            return `${latest.date} ${latest.time}`;
          }
          return "No payments";
        }
      },
      {
        key: "firstPayment",
        label: "First Payment",
        render: (value, row) => {
          if (row.paymentDetails && row.paymentDetails.length > 0) {
            const first = row.paymentDetails[row.paymentDetails.length - 1]; // Last one
            return `${first.date} ${first.time}`;
          }
          return "No payments";
        }
      },
      {
        key: "actions",
        label: "Details",
        render: (value, row) => (
          <button
            onClick={() => this.toggleRow(row.empid)}
            className="btn btn-sm btn-primary"
          >
            {this.state.expandedRows[row.empid] ? "Hide" : "Show"} Details
          </button>
        )
      }
    ];


    return (
      <div className="container-fluid pt-4">
        <CommonLoader isLoading={this.state.loading}>
          <div className="col-sm-12">
            <Card className="mb-3">
              <Card.Header>
                <b>Expense List</b>
              </Card.Header>
              <Card.Body>
                <div className='pnakaj'>
                  <Row className="align-items-end mb-3">
                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label className="required">Employee</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          name="employee"
                          value={this.state.employee}
                          onChange={this.handleFilterChange}
                        >
                          <option value="">Select Employee</option>
                          <option value="all">All Employees</option>
                          {this.state.employeesData.map((emp) => (
                            <option key={emp.id} value={emp.id}>
                              {emp.fullName}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="startDate"
                          value={this.state.startDate}
                          onChange={this.handleFilterChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={3}>
                      <Form.Group>
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="endDate"
                          value={this.state.endDate}
                          onChange={this.handleFilterChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={3} className="d-flex gap-2">
                      {hasPermission('M11B5') && (
                        <Button
                          className="button-filter info"
                          variant="outline-primary"
                          onClick={this.fetchExpenseData}
                        >
                          <i className="fa fa-search"></i>
                        </Button>
                      )}

                    </Col>
                  </Row>
                </div>
                <CommonTableModule columns={columns} data={this.state.employeeWise} />
                {this.state.employeeWise && this.state.employeeWise.map(emp => (
                  this.state.expandedRows[emp.empid] && (
                    <div key={`details-${emp.empid}`} className="mt-3 mb-4 p-3 border rounded">
                      <h6>
                        Payment Details for {emp.employeeName}
                        <span className="text-muted ms-2">(Total: ₹{emp.totalAmount})</span>
                      </h6>

                      {emp.paymentDetails && emp.paymentDetails.length > 0 ? (
                        <table className="table table-sm table-bordered">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Time</th>
                              <th>Amount</th>
                              <th>Type</th>
                              <th>Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {emp.paymentDetails.map(payment => (
                              <tr key={payment.id}>
                                <td>{payment.date}</td>
                                <td>{payment.time}</td>
                                <td>₹{payment.amount}</td>
                                <td>{payment.type}</td>
                                <td>{payment.description}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <p className="text-muted">No payment details available</p>
                      )}
                    </div>
                  )
                ))}
              </Card.Body>
            </Card>
          </div>
        </CommonLoader>
      </div>
    )
  }
}

